import { dateFormatter } from '../../../utils/DateFormatter'
import {
  CASFilenameTemplateItem,
  CASSubtypeFilenameTemplateItem,
  CASTypeFilenameTemplateItem,
} from '../classes/cas'
import dayjs from 'dayjs'

export const CASPackageNumber = new CASFilenameTemplateItem({
  id: 'CFE13217-D13E-49F5-BC36-A097C544B538',
  name: 'Package Number',
  help: 'Submittal Package Number',
  property: 'packageNumber',
  exampleValue: 'CS0001',
})

export const CASPackageName = new CASFilenameTemplateItem({
  id: 'DFB1CF2A-C407-4050-93DB-B6C8381917DC',
  name: 'Package Name',
  help: 'Submittal Package Name',
  property: 'packageName',
  exampleValue: 'Concrete Mix Design - A6505A',
})

export const CASCreatedDate = new CASFilenameTemplateItem({
  id: '174A7128-593E-495C-A591-B98CA15BB56E',
  name: 'Submitted Date',
  help: 'Date Submittal was submitted',
  property: 'createdDate',
  exampleValue: () =>
    dateFormatter(null).file(dayjs().subtract(5, 'days').toDate()),
})

export const CASDispositionDate = new CASFilenameTemplateItem({
  id: '32327B77-2160-41EC-9754-66DFE2F214F1',
  name: 'Disposition Date',
  help: 'Date Disposition was given',
  property: 'dispositionDate',
  exampleValue: () => dateFormatter(null).file(new Date()),
})

export const CASType = new CASTypeFilenameTemplateItem({
  id: '689A4753-181E-4BA1-A000-24E32667500B',
  name: 'Submittal Type',
  help: 'Submittal Package Type',
  property: 'name',
  exampleValue: 'Concrete',
})

export const CASSubtype = new CASSubtypeFilenameTemplateItem({
  id: '9C6E3BFF-2DA3-4D6E-AEAE-B7D7A9913964',
  name: 'Submittal Subtype',
  help: 'Submittal Package Subtype',
  property: 'name',
  exampleValue: 'Mix Design',
})

export type CASFilename =
  | typeof CASPackageNumber
  | typeof CASPackageName
  | typeof CASCreatedDate
  | typeof CASDispositionDate
  | typeof CASType
  | typeof CASSubtype
